import { getAssetUrl } from '../../util'
import { getViews } from '../lib/model-util'
import TipModal from './TipModal'
import statsIcon from '/web/asset/aifans/model-photo-card-stats-icon.png'
import tipsIcon from '/web/asset/aifans/model-photo-card-tips-icon.png'
import { createSignal } from 'solid-js'

interface Props {
  id: string
  characterId: string
  modelName: string
  locked?: boolean
  liked?: boolean
  favorited?: boolean
  url?: string
  likes?: number
  favorites?: number
  onImage: (url: string) => void
  onLike: (id: string) => void
  onFavorite: (id: string) => void
}

const ModelPhotoCard = (props: Props) => {
  const [showTipModal, setShowTipModal] = createSignal(false)
  const viewsStartDate: string = '2024-11-01'

  return (
    <>
      <div class="mb-7 cursor-pointer rounded-3xl bg-gradient-to-r from-cosplay-blue-200/10 to-cosplay-pink-100/10 px-4 pb-5 pt-7 font-clash last:mb-0 md:last:mb-7">
        <div
          class={`overflow-hidden rounded-lg ${props.locked ? 'blur-lg' : ''}`}
          onClick={() => props.url && props.onImage(props.url)}
        >
          <img src={props.url && getAssetUrl(props.url)} class="aspect-square w-full" />
        </div>
        <div class={`mt-6 flex justify-between ${props.locked ? 'blur-md' : ''}`}>
          <button class="flex items-center" onClick={() => props.onLike(props.id)}>
            <img
              src={
                props.liked
                  ? '/images/icons/model-photo-card-heart-icon-filled.png'
                  : '/images/icons/model-photo-card-heart-icon.png'
              }
              class="w-7"
            />
            <span class="mb-1 ml-2 text-xxs">
              {props.likes && props.likes > 0 ? props.likes : ''}
            </span>
          </button>
          <button class="flex items-center" onClick={() => props.onFavorite(props.id)}>
            <img
              src={
                props.favorited
                  ? '/images/icons/model-photo-card-star-icon-filled.png'
                  : '/images/icons/model-photo-card-star-icon.png'
              }
              class="w-7"
            />
          </button>
          <button class="flex items-center">
            <img src={statsIcon} class="w-7" />
            <span class="mb-1 ml-2 text-xxs">{getViews(props.id, viewsStartDate)}</span>
          </button>
          <button class="flex items-center" onClick={() => setShowTipModal(true)}>
            <span class="mr-2 text-sm text-cosplay-pink-200">SEND TIP</span>
            <img src={tipsIcon} class="w-7" />
          </button>
        </div>
      </div>

      <TipModal
        modelName={props.modelName}
        show={showTipModal()}
        onClose={() => setShowTipModal(false)}
        imageId={props.id}
        characterId={props.characterId}
      />
    </>
  )
}

export default ModelPhotoCard
